var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-aside-container"},[_c('div',{staticClass:"avatar"},[(_vm.data.avatar)?_c('Avatar',{attrs:{"src":_vm.avatar}}):_vm._e()],1),_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.data.siteTitle))]),_c('Menu'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }